import { render, staticRenderFns } from "./ButtonAccessibility.vue?vue&type=template&id=038df35f&"
import script from "./ButtonAccessibility.vue?vue&type=script&lang=js&"
export * from "./ButtonAccessibility.vue?vue&type=script&lang=js&"
import style0 from "./ButtonAccessibility.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports